const weekdays = ['L', 'M', 'X', 'J', 'V', 'S', 'D']

const statusTitles = {
  done: 'Hecho',
  missed: 'Fallado',
  today: 'Hoy',
  future: 'Pendiente'
}

// Days of the challenge laid out on a Monday-first week grid, so the
// cells line up with the real calendar.
function startDate(start) {
  return new Date(start + 'T00:00:00')
}

function dateOf(start, day) {
  const date = startDate(start)
  date.setDate(date.getDate() + day - 1)

  return date
}

function mondayOffset(date) {
  return (date.getDay() + 6) % 7
}

function monthLabel(date) {
  return date.toLocaleDateString('es-ES', { month: 'long' })
}

export function Calendar({ calendar }) {
  const { start, days, doneToday } = calendar
  const first = startDate(start)
  const last = dateOf(start, days.length)
  const months =
    first.getMonth() === last.getMonth()
      ? monthLabel(first)
      : `${monthLabel(first)} – ${monthLabel(last)}`

  return (
    <section class="calendar">
      <header class="calendar-head">
        <h2>Calendario</h2>
        <span class="muted">{months}</span>
      </header>
      <div class="calendar-grid">
        {weekdays.map((name) => (
          <span class="calendar-weekday" key={name}>{name}</span>
        ))}
        {Array.from({ length: mondayOffset(first) }, (_, i) => (
          <span class="calendar-pad" key={`pad-${i}`} />
        ))}
        {days.map(({ day, status }) => (
          <Day
            key={day}
            day={day}
            date={dateOf(start, day)}
            status={status}
            done={status === 'done' || (status === 'today' && doneToday)}
          />
        ))}
      </div>
      <p class="calendar-legend muted">
        <span class="legend done">Hecho</span>
        <span class="legend missed">Fallado</span>
        <span class="legend today">Hoy</span>
      </p>
    </section>
  )
}

function Day({ day, date, status, done }) {
  const classes = ['calendar-day', status, done ? 'done' : '']

  return (
    <span
      class={classes.join(' ').trim()}
      title={`Día ${day} · ${statusTitles[status]}`}
    >
      {date.getDate()}
    </span>
  )
}
